import { render } from "./toWork.vue?vue&type=template&id=28464c39&scoped=true"
import script from "./toWork.vue?vue&type=script&lang=js"
export * from "./toWork.vue?vue&type=script&lang=js"

import "./toWork.vue?vue&type=style&index=0&id=28464c39&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28464c39"]])

export default __exports__